import { FC, useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import map from 'lodash/map';
import some from 'lodash/some';
import startCase from 'lodash/startCase';
import Button from 'antd/lib/button/button';
import Divider from 'antd/lib/divider';
import Select from 'antd/lib/select';

import MessageWrapper from 'components/MessageWrapper/MessageWrapper';
import { productTagsSelector } from 'store/selectors/listsSelectors';
import { bulkUpdateProductsAction, getProductsTagsAction, updateProductAction } from 'store/actions/listsActions';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { EEditType } from 'types/commonEnums';
import { ErrorIcn } from 'utils/icons';

interface IProductsEditTagsProps {
  ids: string[],
  isBulk?: boolean,
  isActive?: boolean,
  type: EEditType,
  productTags?: string[],
  onModalClose: () => void,
}

const { Option } = Select;
const tagRexExp = new RegExp(/^[\w\-?,.@!`'()+\/\[\]<>{}$€£*%=#;:\n\s ]+$/g);

const ProductsEditTags: FC<IProductsEditTagsProps> = ({
  ids,
  isBulk = false,
  type,
  productTags = [],
  onModalClose,
}) => {
  const dispatch = useDispatch();
  const { isUpdated, tagsList } = useTypedSelector(productTagsSelector);
  const [tags, setTags] = useState<string[]>(productTags);
  const isInvalidTags = useMemo(() => some(tags, (tag) => !tag.trim().match(tagRexExp)), [tags]);

  const handleUpdate = async() => {
    const action = isBulk ? bulkUpdateProductsAction : updateProductAction;

    await dispatch(action({ ids, type, tags }));
    onModalClose();
  };

  useEffect(() => {
    !isUpdated && dispatch(getProductsTagsAction());
  }, []);

  return (
    <div className="w-96">
      <h2 className="mt-4">{startCase(type)} Tags</h2>
      <Select
        showArrow
        mode="tags"
        size="large"
        loading={!isUpdated}
        className="w-full"
        value={tags}
        placeholder="Enter tag name"
        onChange={setTags}
        maxTagTextLength={10}
        maxTagCount={10}
      >
        {map(tagsList, (tag) => <Option key={tag} value={tag}>{tag}</Option>)}
      </Select>
      <MessageWrapper isVisible={isInvalidTags} className="mt-2.5 text-red-50 bg-red-50/20">
        <ErrorIcn />Tag must can only contain Latin letters and numbers
      </MessageWrapper>
      <Divider />
      <Button
        size="large"
        type="primary"
        className="block ml-auto"
        disabled={isInvalidTags}
        onClick={handleUpdate}
      >
        Done
      </Button>
    </div>
  );
};

export default ProductsEditTags;
